import React from 'react';
import { Col, Form, Row, Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';

const CheckboxesSection = ({ isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6} />
      <Col span={6}>
        <Form.Item
          label={t('Idea regalo')}
          name='gift_idea'
          valuePropName={'checked'}
        >
          <Checkbox disabled={isView} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(CheckboxesSection);
